import React from "react";
import Screen from "../../components/Screen";
import {toI18N} from "../../utils/I18n";
import Box, {Direction} from "../../components/Box";
import Title from "../../components/Title";
import SVG from "react-inlinesvg";
import classNames from "classnames";
import iconStyles from "../../css/Icon.module.css";
import swipeBoth from "../../images/swipe-both.svg";
import Text from "../../components/Text";
import tap from "../../images/tap.svg";
import swipeLeft from "../../images/swipe-left.svg";
import appStyles from "../../css/App.module.css";
import Button from "../../components/Button";

interface Props {
    onClose?: () => void
    previewHint?: string,
}


export default (props: Props) => {
    const {onClose, previewHint} = props;
    return (
        <Screen
            // @ts-ignore
            title={""}
            subtitle={""}
            hideBack
            hideNext
        >
            <Box flex sideMargin topMargin={40} center>
                <Title shrink
                       title={toI18N("preview_screen_title")}
                       subtitle={previewHint || toI18N("preview_screen_subtitle")}
                />
            </Box>
            <Box flex sideMargin shrink>
                <Box direction={Direction.Clear} rightMargin={4}>
                    <SVG
                        className={classNames(iconStyles.icon)}
                        src={swipeBoth}/>
                </Box>
                <Text size={16}>{toI18N('preview_screen_swipe_instruction')}</Text>
            </Box>
            {
                onClose &&
                <Box flex topMargin={12} sideMargin shrink>
                    <Box direction={Direction.Clear} rightMargin={4}>
                        <SVG
                            className={classNames(iconStyles.icon)}
                            src={tap}/>
                    </Box>
                    <Text size={16}>{toI18N('preview_screen_tap_instruction')}</Text>
                </Box>
            }
            <Box flex topMargin={24} center>
                <Box direction={Direction.Column}>
                    <Text size={20} fontWeight={600}>{toI18N('preview_screen_start_swipe_left')}</Text>
                    <Box center topMargin={12}>
                        <SVG
                            className={classNames([iconStyles.icon, iconStyles.iconXXl])}
                            src={swipeLeft}/>
                    </Box>
                </Box>
            </Box>
            {
                onClose &&
                <Box flex className={appStyles.columnVerticalCenter} topMargin={24} direction={Direction.Column} sideMargin
                     center>
                    <Button minWidth={172} primary onClick={onClose}>
                        {toI18N("preview_screen_close")}
                    </Button>
                </Box>
            }
        </Screen>
    )
}
